module.exports = __webpack_public_path__ + "img/industry-4.350db143.jpg";